import { Badge } from "@/components/ui/badge";
import { ChevronRight } from "lucide-react";

function ProviderBadge({ sub }) {
  const active = sub.active_provider;
  return (
    <div className="flex items-center gap-1.5">
      {sub.square?.configured && (
        <span className={`px-2 py-0.5 rounded-full text-[10px] font-mono font-semibold border ${active === "square" ? "bg-emerald-500/15 text-emerald-400 border-emerald-500/40" : "bg-emerald-500/5 text-emerald-500/60 border-emerald-500/20"}`}>
          SQUARE
        </span>
      )}
      {sub.stripe?.configured && (
        <span className={`px-2 py-0.5 rounded-full text-[10px] font-mono font-semibold border ${active === "stripe" ? "bg-indigo-500/15 text-indigo-400 border-indigo-500/40" : "bg-indigo-500/5 text-indigo-500/60 border-indigo-500/20"}`}>
          STRIPE
        </span>
      )}
      {!sub.square?.configured && !sub.stripe?.configured && (
        <span className="px-2 py-0.5 rounded-full text-[10px] font-mono text-muted-foreground border border-border">
          NOT SET
        </span>
      )}
    </div>
  );
}

export default function SubAccountList({ subs, selectedId, onSelect }) {
  if (!subs.length) {
    return (
      <div className="text-sm text-muted-foreground p-6 text-center border border-dashed border-border rounded-lg">
        No sub-accounts yet. Create one to generate a checkout endpoint.
      </div>
    );
  }
  return (
    <div className="space-y-2" data-testid="subaccount-list">
      {subs.map((s) => (
        <button
          key={s.id}
          data-testid={`subaccount-item-${s.id}`}
          onClick={() => onSelect(s.id)}
          className={`w-full text-left rounded-lg border p-3.5 transition-all hover:-translate-y-0.5 ${
            selectedId === s.id
              ? "border-primary/60 bg-primary/5"
              : "border-border/70 bg-card hover:border-primary/40"
          }`}
        >
          <div className="flex items-center justify-between">
            <span className="font-heading font-semibold truncate">{s.name}</span>
            <ChevronRight className={`h-4 w-4 shrink-0 ${selectedId === s.id ? "text-primary" : "text-muted-foreground"}`} />
          </div>
          <div className="mt-1 font-mono text-[11px] text-muted-foreground truncate">
            GHL · {s.ghl_subaccount_id}
          </div>
          <div className="mt-2">
            <ProviderBadge sub={s} />
          </div>
        </button>
      ))}
    </div>
  );
}
